import { Component, Vue } from "vue-facing-decorator";
import { STORE_MUTATION } from "../enums/store_mutation";
import { __vueEvent } from "../constant";
import { EVENTS } from "../enums";
import { IConfig } from "../interfaces/config";
import Banner from "../components/banner.vue";
import { Util } from "../util";
declare var SatisfiApp;
@Component({
    components: { Banner }
})
export default class Header extends Vue {

    pageTitle = "";
    isHeaderImage = false;
    hideHeader = false;
    triggerUnhideInputInterval;
    destinationURL = "";
    isUnhideInputInitiated = true;
	hideHeaderCloseIFrame = true;

	// SD-1837: Add Ability to set back button label when showing IFrame
	backButtonLabelIFrame = "Return to Chat";

    //#region Computed Properties

    get shouldShowBanner() {
      return this.$store.state.shouldShowBanner || false;
    }

    get isIFrameLoaded() {
      return this.$store.state.isIFrameLoaded || false;
    }

    //#endregion

    mounted() {
        this.listenEvents();
    }

    listenEvents() {
      // Listen for the SetConfig event
      __vueEvent.once(EVENTS.SetConfig, (config: IConfig) => {
        this.pageTitle = config.pageTitle.length > 0 ? config.pageTitle : config.pageName;
        this.isHeaderImage = String(config.headerImage).length > 0;
        this.hideHeader = config.hidePageTitle;
        this.destinationURL = config.headerImageDestinationURL || "";
      });

      // Listen for the UrlOpenedInIFrame event
      __vueEvent.on(EVENTS.UrlOpenedInIFrame, (iframeBackButtonLabel: any) => {
        // if the settings.browserTarget is "iframe"
        // This means url has been opened in a iframe.
        // So now we will show the close iframe button in the header
        this.hideHeaderCloseIFrame = false;
        this.updateHeaderHeight("42px");

        // SD-1837: Add Ability to set back button label when showing IFrame
        this.backButtonLabelIFrame = "Return to Chat";
        if (iframeBackButtonLabel != null) {
          this.backButtonLabelIFrame = iframeBackButtonLabel;
        }
      });

      // Listen for the UrlOpenedInIFrameFromMain event
      __vueEvent.on(EVENTS.UrlOpenedInIFrameFromMain, () => {
        this.hideHeaderCloseIFrame = false;
        this.updateHeaderHeight("42px");
      });
    }

	updateHeaderHeight(inputHeight: string, setTempHeight = true) {
        try {
            let compStyles = window.getComputedStyle(document.documentElement);
            if (compStyles) {
                // Check if the `--chatFooterHeight` var is present
                let headerHeight = compStyles.getPropertyValue('--headerHeight');
                if (!!headerHeight) {
					document.documentElement.style.setProperty('--tempHeaderHeight', setTempHeight ? headerHeight : "0");
                    document.documentElement.style.setProperty('--headerHeight', inputHeight);
                }
            }
        } catch (ex) {}
    }

    headerContainerMousedown() {
        //On mouse down of header for 5 sec show input container
        this.isUnhideInputInitiated = true;
        this.triggerUnhideInputInterval = setInterval(() => {
            this.isUnhideInputInitiated = false;
            this.$store.commit(STORE_MUTATION.SetDisableInput, false);
            this.$store.commit(STORE_MUTATION.SetDefaulthideInputContainerSetting, false);
            clearInterval(this.triggerUnhideInputInterval);
        }, 5000);
    }

    headerContainerMouseup() {
        //On mouse up on header clear interval to show input container
        clearInterval(this.triggerUnhideInputInterval);
    }

    // Event handler for the header image click
    headerImageClick() {
      try {
        // If only a headerImageDestinationURL are present,
        // then only open the url in a new tab
        const vm = this;
        const isDestinationURL = String(vm.destinationURL).length > 0;
        if (isDestinationURL && !vm.hideHeader && vm.isUnhideInputInitiated) {
            //SD-6795: Add tracking URL for header image click
            const trackingUrl = this.$store.state.headerImageDestTrackingURL || "";
            const href = !Util.isNullOrEmpty(trackingUrl) ? trackingUrl : vm.destinationURL;
            if (!href) return; // Skip redirect if href is null or empty

            const a = document.createElement("a");
            a.href = href;
            a.rel = "noreferrer noopener";
            a.target = "_blank";
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
      } catch (ex) {
        console.error("Error in header.ts:headerImageClick", ex);
      }
    }

	// Hide the IFrame overlay
	hideIFrame() {
        var ifrm = document.getElementById("remote_browser_target");
		if(ifrm) {
			// Just remove the iframe, just like we do for new tabs
			ifrm.remove();
			//ifrm.style.display = "none";
			// Clear the content of an IFRAME, to prevent any cache issues
			//ifrm.setAttribute("src", "about:blank");
		}
		return false;
    }

	// Event handler for the header close IFrame icon click
	headerCloseIFrameClick() {
		try {
			this.hideHeaderCloseIFrame = true;
			this.hideIFrame();
			__vueEvent.emit(EVENTS.HideCloseIFrameIcon);
			let compStyles = window.getComputedStyle(document.documentElement);
			if (compStyles) {
				let headerHeight = compStyles.getPropertyValue("--tempHeaderHeight");
				if (!!headerHeight) {
					this.updateHeaderHeight(headerHeight, false);
				}
			}
		} catch (ex) {}
	}
}
